<template>
  <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="21px"
    height="21px"
    viewBox="0 0 21 21"
    enable-background="new 0 0 21 21"
    xml:space="preserve"
  >
    <g id="icon">
      <path
        d="M6.6799,18h7.6395c0.8564,0,1.6805,-0.3252,2.3077,-0.9083c1.5863,-1.475,2.6396,-3.5153,2.8386,-5.8006c0.475,-5.4535,-4.0687,-10.1129,-9.5323,-9.7736C5.2268,1.8099,1.5,5.7197,1.5,10.5c0,2.6233,1.1226,4.9842,2.9135,6.6292C5.03,17.6955,5.8428,18,6.6799,18z"
        fill="none"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-linejoin="round"
      />
      <circle
        cx="10.5"
        cy="14"
        r="1.5"
        fill="none"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-linejoin="round"
      />
      <line
        x1="11.497"
        y1="12.6"
        x2="15.1"
        y2="7.7"
        fill="none"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-linejoin="round"
      />
      <path
        d="M3.5,10.5c0,-3.866,3.134,-7,7,-7s7,3.134,7,7"
        fill="none"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-linejoin="round"
      />
    </g>
  </svg>
</template>

<script setup lang="ts"></script>
